import { SafeHtml } from '@angular/platform-browser';

/**
 * Configuration to describe an RDS API query
 */
export class RdsRawApiQuery {
  /**
   * @param html Formatted html to represent the api query
   * @param path The actual encoded path, useful for copy and pasting into the browser
   */
  constructor(public html: SafeHtml, public path: string) {}
}
